import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { getRandomInt } from '../../../helpers/Utils'
import { SpecialRequestFormField } from '../../../types/enums'
import { IElementProps } from '../../../types/interfaces'

const CustomersSelectUnlinked = (props: IElementProps) => {
  const { t } = useTranslation('common')

  const optionsToRender = Object.entries(props.externalData?.data ?? {}).map(([key, value]) => ({
    name: value,
    value: key,
    enabledWhen: true,
  }))

  const [valueWasSet, setValueWasSet] = useState<boolean>(false)

  const handleCHange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    props.handleChange(props.name, e, false, SpecialRequestFormField.CustomersSelectUnlinked)
  }

  useEffect(() => {
    if (!valueWasSet) {
      setValueWasSet(true)

      setTimeout(() => {
        handleCHange({
          target: {
            value: props.value,
          },
        } as React.ChangeEvent<HTMLSelectElement>)
      }, getRandomInt(50, 100))
    }
  }, [props.value])

  return (
    <>
      {props.visible && (
        <div className="formGroup">
          <div className="labelTooltip">
            {props.translatedTooltip && (
              <>
                <div className="tooltipArea">
                  <i className="icon-info"></i>
                  <div className="tooltip">{props.translatedTooltip}</div>
                </div>
              </>
            )}
            <label>{props.label}</label>
          </div>
          <div className="selectArea selectfuelCard required-highlight">
            <select
              onChange={(e) => handleCHange(e)}
              value={props.value || ''}
              disabled={props.formReadOnly || props.disabledInput}
            >
              {props.formReadOnly && !(optionsToRender?.filter((o) => o.value === props.value)?.length > 0) ? (
                <>
                  <option value={props.value || ''}>{props.value || ''}</option>
                </>
              ) : (
                <>
                  <option disabled={true} value="">
                    {optionsToRender.length > 0 ? t('PLEASE_SELECT_A_VALUE') : t('NO_VALUE_TO_SHOW')}
                  </option>
                  {optionsToRender.length > 0 &&
                    optionsToRender.map((option) => (
                      <option value={option.value} key={option.name} disabled={!option.enabledWhen}>
                        {option.name}
                      </option>
                    ))}
                </>
              )}
            </select>
            <i className="icon-bottom" />
          </div>
        </div>
      )}
    </>
  )
}
export default CustomersSelectUnlinked
